<script>
  import { inertia } from '@inertiajs/svelte';
  import { page } from '@inertiajs/svelte';
  export let back;
</script>

<div class="back">
  <a class="btn-icon btn back__btn" href={back.url} use:inertia>
    <i class="isax isax-arrow-left4" />
    <span>{$page.props.i18n.back}</span>
  </a>
</div>

<style lang="scss">
  .back {
    padding: 10rem 0;
    text-align: center;

    @include resp-max('m') {
      padding: 7rem 0;
    }

    @include resp-max('s') {
      padding: 5rem 0;
    }

    &__btn {
      margin: 0 auto;
      padding: 1rem 0;
      border-bottom: solid 1.5px var(--aqua-1);
      font-size: 1.5rem;

      & i {
        font-weight: 900;
      }

      &:hover {
        color: var(--aqua-1);
      }
    }
  }
</style>
